import React from 'react';
import clsx from 'clsx';
import { Box, Card, Typography } from '@curves/ui-base';

import {parseDate} from '@Util/moment.util';
import {isEmpty} from '@Util/utils';
import {DATE_TIME_STANDARD} from '@Constants/appConfig';
/**
 * 訂單紀錄區塊組件
 *
 * 功能：
 * - 顯示訂單的處理紀錄
 * - 包含時間、操作內容等資訊
 *
 * @component
 * @param {Object} props - 組件屬性
 * @param {string} props.className - 自定義樣式類名
 * @param {Array} [props.sourceData=[]] - 訂單紀錄資料
 * @returns {JSX.Element} 訂單紀錄區塊
 */
const OrderRecordsSection = ({className,sourceData = []}) => {
    return (
        <Card className={clsx("px-3 pt-2 pb-3", className)}>
            <Card.CardContent>
                <Typography variant="body1" className={'mb-2'}>
                    訂單紀錄
                </Typography>
                {
                    !isEmpty(sourceData) ? (
                        <ul className="order-history">
                            {
                                sourceData.map(({recordID, title, returnNotes, recordDate}) => (
                                    <li key={recordID} className="order-history-item">
                                        <Box className="d-flex justify-content-between">
                                            <Box className="order-history-item-title">{title}</Box>
                                            { returnNotes && <Box>{returnNotes}</Box>}
                                            <Box className="order-history-item-subtitle">{parseDate(recordDate, DATE_TIME_STANDARD.DISPLAYFULLBYSLASH)}</Box>
                                        </Box>
                                    </li>
                                ))
                            }
                        </ul>
                    ) : null
                }
            </Card.CardContent>
        </Card>
    )
};
export default OrderRecordsSection;
